import { SVGProps } from 'react';

const Shoot = (props: SVGProps<SVGSVGElement>) => (
    <svg width="100%" height="100%" viewBox="0 0 200 200" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="Shoot1">
            <circle cx="100" cy="100" r="58.87" fill="none" strokeWidth={7.5} />
            <circle cx="100" cy="100" r="7.5" />
            <rect x="21.277" y="96.25" width="39.706" height="7.5" />
            <rect x="139.017" y="96.25" width="39.706" height="7.5" />
            <path d="M103.75,60.983l0,-39.706l-7.5,0l0,39.706l7.5,0Z" />
            <path d="M103.75,178.723l0,-39.706l-7.5,0l0,39.706l7.5,0Z" />
        </g>
    </svg>
);

export default Shoot;
